import { Box, Grid2, RadioGroup, styled } from "@mui/material";

const PREFIX = "quiz";
export const classes = {
  centered: `${PREFIX}-centered`,
  container: `${PREFIX}-container`,
  baseRow: `${PREFIX}-baseRow`,
  numberColumn: `${PREFIX}-numberColumn`,
  answerGroup: `${PREFIX}-answerGroup`,
  answerHeader: `${PREFIX}-answerHeader`,
  questionColumn: `${PREFIX}-questionColumn`,
  labelCtrl: `${PREFIX}-labelCtrl`,
  answerContainer: `${PREFIX}-answerContainer`,
  mainContainer: `${PREFIX}-mainContainer`,
  quizContainer: `${PREFIX}-quizContainer`,
  questionNumbers: `${PREFIX}-questionNumbers`,
  questionGrid: `${PREFIX}-questionGrid`,
  questionText: `${PREFIX}-questionText`,
  questionDivider: `${PREFIX}-questionDivider`,
};

export const BackgroundBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  [`& .${classes.container}`]: {
    maxWidth: "1600px",
    margin: "0 auto",
    padding: "0px 24px",
    "@media (max-width: 600px)": {
      padding: "0px 6px",
    },
  },
}));

export const QuizRadioGroup = styled(RadioGroup)(() => ({
  width: "100%",
  margin: "20px 0px",
  [`& .${classes.labelCtrl}`]: {
    marginLeft: 0,
    marginRight: 0,
    width: "150px",
    "& .MuiFormControlLabel-label": {
      textAlign: "center",
    },
  },
  [`& .${classes.answerGroup}`]: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
    width: "100%",
    flexWrap: "nowrap",
  },
}));

export const QuizGrid = styled(Grid2)(({ theme }) => ({
  width: "100%",
  height: "100%",
  paddingTop: 20,
  paddingBottom: 20,
  [`& .${classes.centered}`]: {
    textAlign: "center",
  },
  [`& .${classes.answerContainer}`]: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-evenly",
  },
  [`& .${classes.mainContainer}`]: {
    width: "100%",
    alignItems: "center",
    alignText: "center",
  },
  [`& .${classes.baseRow}`]: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "end",
    paddingTop: 10,
    minHeight: "170px",
  },
  [`& .${classes.numberColumn}`]: {
    width: "20px",
    paddingLeft: "5px",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
  },

  [`& .${classes.answerHeader}`]: {
    fontWeight: "bold",
    fontSize: 14,
  },
  [`& .${classes.questionNumbers}`]: {
    paddingLeft: 5,
    alignItems: "center",
    fontWeight: "normal",
    justifyContent: "center",
    marginBottom: "5px",
    fontSize: 24,
  },
  [`& .${classes.questionColumn}`]: {
    paddingLeft: 5,
    alignItems: "center",
    fontWeight: "bold",
    justifyContent: "center",
    textAlign: "center",
  },
  [`& .${classes.quizContainer}`]: {
    "&. MuiGrid-root": {
      background: theme.palette.background.default,
    },
  },
  [`& .${classes.questionGrid}`]: {
    backgroundColor: theme.palette.background.level1,
    border: "1px solid rgb(0 0 0 / 10%)",
    borderRadius: "8px",
    boxShadow:
      "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
    padding: "20px 40px",
    "@media(max-width: 900px)": {
      padding: "10px 20px",
    },
    "@media(max-width: 600px)": {
      padding: "10px 5px",
    },
  },
  [`& .${classes.questionText}`]: {
    display: "flex",
    fontSize: 24,
    color: theme.palette.primary.main,
  },
  [`& .${classes.questionDivider}`]: {
    "& .MuiDivider-root": {
      borderColor: theme.palette.grey.dark,
      borderBottomWidth: "medium",
    },
  },
}));
